import React from 'react';
import Pnavbar from '../components/JSX/Pnavbar';
import Slider5 from '../components/JSX/Slider5';
import All from '../components/JSX/All';

import Footerp from '../components/JSX/Footerp';

const Projects = () => (
  <>
    <Pnavbar />
    <Slider5 />
    <All/>
    <Footerp/>
  </>
);

export default Projects;